module.exports = __webpack_public_path__ + "img/img6.b0af42a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/05/img6.png
// module id = 245
// module chunks = 0